import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/details/details';

class Details {
  constructor() {
    this.detailsGroupEl = document.querySelectorAll('[data-details-group]');

    this.toggle = this.toggle.bind(this);

    this.addEventListeners();
  }

  addEventListeners() {
    this.detailsGroupEl.forEach(el => el.addEventListener('sl-show', this.toggle));
  }

  toggle(evt) {
    // Close all other details, when one is shown
    // @see https://shoelace.style/components/details#grouping-details
    if (evt.target.localName === 'sl-details') {
      const container = evt.currentTarget;
      [...container.querySelectorAll('sl-details')].map(details => (details.open = evt.target === details));
    }
  }
}
export default new Details();
